import { Flex } from '@chakra-ui/react';

type FormRowProps = {
  children: React.ReactNode;
};

export const FormRow = ({ children }: FormRowProps) => {
  return (
    <Flex gap={4} flexDirection={{ base: 'column', md: 'row' }}>
      {children}
    </Flex>
  );
};
